import { render, staticRenderFns } from "./LpuLoyaltyProgramLabel.vue?vue&type=template&id=e7318fac&"
import script from "./LpuLoyaltyProgramLabel.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuLoyaltyProgramLabel.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7318fac')) {
      api.createRecord('e7318fac', component.options)
    } else {
      api.reload('e7318fac', component.options)
    }
    module.hot.accept("./LpuLoyaltyProgramLabel.vue?vue&type=template&id=e7318fac&", function () {
      api.rerender('e7318fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LpuLoyaltyProgram/components/LpuLoyaltyProgramLabel.vue"
export default component.exports